module.exports = __webpack_public_path__ + "static/media/feature5.ca9e7810.png";